import {
    IGetInternationalCompaniesResponse,
    IGetInternationalCompanyDataResponse,
    IGetInternationalCompanyGroupResponse,
    IGetInternationalCompanyGroupsResponse,
    IUpdateInternationalCompanyGroupRequest,
} from 'types';
import { cdmApi } from '.';

const PREFIX = '/international-company-groups';

const InternationalCompanyGroupsApi = cdmApi.injectEndpoints({
    endpoints: (builder) => ({
        getInternationalCompanyGroups: builder.query<IGetInternationalCompanyGroupsResponse, void>({
            query: (params) => ({ url: `${PREFIX}/`, method: 'get', params }),
            providesTags: () => [{ type: 'InternationalCompanyGroup', id: 'LIST' }],
        }),

        getInternationalCompanyGroup: builder.query<
            IGetInternationalCompanyGroupResponse,
            {
                globalCompanyId: number;
                internationalCompanyGroupId: number;
            }
        >({
            query: (params) => ({
                url: `${PREFIX}/${params.internationalCompanyGroupId}`,
                method: 'get',
            }),
            providesTags: () => [{ type: 'InternationalCompanyGroup', id: 'LIST' }],
        }),

        getAllInternationalCompanies: builder.query<IGetInternationalCompaniesResponse, void>({
            query: () => ({
                url: `${PREFIX}/international-companies`,
                method: 'get',
            }),
        }),
        getCompanyGroups: builder.query<IGetInternationalCompanyGroupsResponse, number>({
            query: (internationalCompanyId) => ({
                url: `${PREFIX}/internationalCompanies/${internationalCompanyId}/company-groups`,
                method: 'get',
            }),
        }),

        getInternationalCompanyData: builder.query<
            IGetInternationalCompanyDataResponse,
            { internationalCompanyId: number }
        >({
            query: (params) => ({
                url: `${PREFIX}/internationalCompanies/${params.internationalCompanyId}`,
                method: 'get',
            }),
        }),

        addInternationalCompanyGroup: builder.mutation<any, IUpdateInternationalCompanyGroupRequest>({
            query: (data) => ({
                url: `${PREFIX}/`,
                method: 'post',
                data,
            }),
            invalidatesTags: [{ type: 'InternationalCompanyGroup', id: 'LIST' }],
        }),

        updateInternationalCompanyGroup: builder.mutation<any, IUpdateInternationalCompanyGroupRequest>({
            query: (data) => ({
                url: `${PREFIX}/${data.internationalCompanyGroupId}`,
                method: 'put',
                data,
            }),
            invalidatesTags: [{ type: 'InternationalCompanyGroup', id: 'LIST' }],
        }),

        deleteInternationalCompanyGroup: builder.mutation<
            any,
            { globalCompanyId: number; internationalCompanyGroupId: number }
        >({
            query: (params) => ({
                url: `${PREFIX}/${params.internationalCompanyGroupId}`,
                method: 'delete',
            }),
            invalidatesTags: [{ type: 'InternationalCompanyGroup', id: 'LIST' }],
        }),
    }),

    overrideExisting: false,
});

export const {
    useGetInternationalCompanyGroupsQuery,
    useLazyGetInternationalCompanyGroupQuery,
    useGetAllInternationalCompaniesQuery,
    useLazyGetInternationalCompanyDataQuery,
    useUpdateInternationalCompanyGroupMutation,
    useAddInternationalCompanyGroupMutation,
    useDeleteInternationalCompanyGroupMutation,
    useLazyGetCompanyGroupsQuery,
} = InternationalCompanyGroupsApi;
